import React from 'react';
import { Svg } from './base/Svg';
export const InfoI = ({ size = 'small' }) => {
    return (React.createElement(Svg, { size: size },
        React.createElement("path", { d: "M11.5,17 L11.5,10 M11.5,8 L11.5,6", stroke: "currentColor", strokeWidth: "1" }),
        React.createElement("circle", { id: "Oval", cx: "11.5", cy: "11.5", r: "11", stroke: "currentColor", strokeWidth: "1", fill: "none" })));
};
